import { Field, Label, Textarea } from "@headlessui/react"

interface IMultiTextFieldProps {
  label: string
  placeholder?: string
  value?: string
  onChange?: (value: string) => void
  error?: boolean
  maxLength?: number
}

export const MultiTextField = (props: IMultiTextFieldProps) => {
  return (
    <Field>
      <Label className={'text-lg'}>{props.label}</Label>
      <div className={'relative'}>
        <Textarea
          placeholder={props.placeholder}
          value={props.value}
          onChange={(e) => props.onChange?.(e.target.value)}
          maxLength={props.maxLength}
          className={
            `mt-3 block w-full appearance-none rounded-lg border-1 px-3 py-3 text-base data-focus:outline-formBorder resize-none ${
              props.error ? 'border-red-500' : 'border-formBorder'
            }`
          }
          rows={4}
        />
      </div>
    </Field>
  )
}
